/**
 * Created by vsuthar on 8/18/21
 * File: NoDataScreen
 * Project: Cloud Management Module ©Palo Alto Networks
 * © Palo Alto Networks
 */
import { Button, Body } from '@panwds/react-ui'
import {
  BUTTON_ADD_TENANT,
  BUTTON_LEARN_MORE,
  TENANCY_NO_DATA_HELPER,
  TENANCY_NOT_SETUP_TENANT,
} from '../../constants/LabelConstants'

/**
 *
 * @param {*} onAddTenantClick: callback when user click on the Add Tenant Button
 * @returns
 */
const NoDataScreen = ({ onAddTenantClick }) => {
  return (
    <div className={'tw-flex tw-flex-1 tw-flex-col tw-justify-center tw-items-center'}>
      <Body>{TENANCY_NOT_SETUP_TENANT}</Body>
      <Body>{TENANCY_NO_DATA_HELPER}</Body>
      <div className="tw-flex tw-flex-row tw-space-x-4 tw-m-1">
        <Button size={'lg'}
          appearance="clear">
          {BUTTON_LEARN_MORE}
        </Button>
        <Button size={'lg'}
          appearance="primary"
          onClick={onAddTenantClick}>
          {BUTTON_ADD_TENANT}
        </Button>
      </div>
    </div>
  )
}

export default NoDataScreen
